export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center mb-10">
          <h2 className="text-foreground-950 font-heading text-3xl md:text-5xl font-bold mb-4">
            Ready to Buy Smarter?
          </h2>
          <p className="text-foreground-500 text-base md:text-lg mb-8 font-body">
            Stop overpaying on every China order. Start using the ACBuySpreadsheet system today and join thousands of savvy shoppers saving 30-40% on every purchase.
          </p>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-4 rounded-full text-lg font-semibold transition-all cursor-pointer whitespace-nowrap font-label"
          >
            buy it now
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
          {[
            'https://readdy.ai/api/search-image?query=Minimalist%20white%20sneaker%20diagonally%20placed%20on%20terrazzo%20surface%2C%20bright%20natural%20studio%20light%2C%20clean%20modern%20product%20photography%2C%20subtle%20shadow%20detail%2C%20editorial%20fashion%20still%20life%2C%20soft%20warm%20undertone%2C%20sophisticated%20composition&width=300&height=300&seq=cta-product-unique-01&orientation=squarish',
            'https://readdy.ai/api/search-image?query=Pastel%20yellow%20hoodie%20folded%20on%20light%20oak%20wood%20surface%2C%20soft%20window%20light%2C%20cozy%20minimalist%20photography%2C%20fabric%20texture%20visible%2C%20Scandinavian%20aesthetic%2C%20warm%20spring%20tones%2C%20clean%20editorial%20still%20life&width=300&height=300&seq=cta-product-unique-02&orientation=squarish',
            'https://readdy.ai/api/search-image?query=Structured%20sage%20green%20tote%20handbag%20standing%20on%20white%20marble%2C%20natural%20daylight%2C%20luxury%20minimal%20product%20shot%2C%20architectural%20shadow%20play%2C%20sophisticated%20accessories%20photography%2C%20warm%20neutral%20palette&width=300&height=300&seq=cta-product-unique-03&orientation=squarish',
            'https://readdy.ai/api/search-image?query=Beige%20baseball%20cap%20resting%20on%20smooth%20concrete%20surface%2C%20golden%20hour%20side%20light%2C%20urban%20minimal%20photography%2C%20warm%20sunset%20tones%2C%20clean%20contemporary%20aesthetic%2C%20editorial%20accessories%20still%20life&width=300&height=300&seq=cta-product-unique-04&orientation=squarish',
            'https://readdy.ai/api/search-image?query=Lightweight%20cream%20jacket%20draped%20over%20wooden%20hanger%20against%20soft%20grey%20wall%2C%20diffused%20natural%20light%2C%20minimal%20fashion%20photography%2C%20elegant%20simplicity%2C%20warm%20neutral%20tones%2C%20sophisticated%20editorial%20composition&width=300&height=300&seq=cta-product-unique-05&orientation=squarish',
          ].map((src, i) => (
            <div key={i} className="w-20 h-20 md:w-24 md:h-24 rounded-2xl overflow-hidden bg-background-100">
              <img
                src={src}
                alt={`ACBuySpreadsheet product ${i + 1}`}
                title={`ACBuySpreadsheet featured product ${i + 1}`}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}